
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[id]",
      function () {
        return require("private-next-pages/users/[id]/index.tsx");
      }
    ]);
  